import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Messages } from 'src/app/shared/constant/messages';
import { LoaderService, RequestService, SessionManagerService, ToastService } from 'src/app/shared/services';
import { Constants } from 'src/app/shared/constant/constants';
import { FirebaseAuthService } from '../../services/firebase-auth.service';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-code-popup',
  templateUrl: './user-code-popup.component.html',
  styleUrls: ['./user-code-popup.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, TranslateModule],
})
export class UserCodePopupComponent {
  @Input() email!: string;
  @Input() password!: string;
  @Input() type!: boolean;
  useCodeForm!: UntypedFormGroup;
  CommonConfig = Messages;
  data: { [key: string]: any } = {};
  constructor(
    private modalService: BsModalService,
    private fb: UntypedFormBuilder,
    private sessionManagerService: SessionManagerService,
    private loader: LoaderService,
    private requestService: RequestService,
    private flashMessage: ToastService,
    private firebaseAuthService: FirebaseAuthService,
  ) {
    this.useCodeForm = this.fb.group({
      licenseCode: ['', [Validators.required]],
    });
  }

  get f() {
    return this.useCodeForm.controls;
  }

  useCode() {
    this.useCodeForm.markAllAsTouched();
    if (!this.useCodeForm.invalid) {
      this.loader.start();
      this.data = {
        username: this.email,
        password: this.password,
        licenseCode: this.useCodeForm.value.licenseCode,
        isSocialLogin: this.type,
      };

      this.requestService.post(Constants.ENDPOINTS.applyCodeEmail, this.data).subscribe(
        (res: any) => {
          if (res.data) {
            this.modalService.hide();
            if (res.data.activeToken && res.data.role === Constants.ROLE_IDS.USER) {
              this.sessionManagerService.createSession(
                res.data.activeToken,
                res.data.role,
                res.data.id,
                res.data.levelId ? res.data.levelId : '',
                res.data.levelNo,
                res.data.email,
              );
              const isSubscriptionMandatory = res.data.isSubscriptionMandatory == false ? '0' : '1';
              const isLicenseCodeUsed = res.data.isLicenseCodeUsed == false ? '0' : '1';
              this.sessionManagerService.setSubscriptionInfo(res.data?.subscriptionInfo);
              this.sessionManagerService.setIsSubcrpition(isSubscriptionMandatory);
              this.sessionManagerService.setIsLicenseCodeUsed(isLicenseCodeUsed);
              this.sessionManagerService.setPlanInfo(res.data?.planInfo);
              this.firebaseAuthService.loginWithToken(res.data.firebaseToken, res);
            }
          }
          this.loader.stop();
        },
        error => {
          this.loader.stop();
          this.flashMessage.showError(error.error.errorMessage);
        },
      );
    }
  }

  toCancel() {
    this.useCodeForm.reset();
    this.modalService.hide();
  }
}
